import { z } from 'zod';

export type CameraPreview = z.infer<typeof cameraPreviewSchema>;

export const cameraPreviewSchema = z.object({
  cameraName: z.string(),
  screenshotUrl: z.string().optional(),
  vendorCameraId: z.string(),
});
